import transpile from "./Transpile";

const log = console.log;
const warn = console.warn;
const error = console.error;
const clear = console.clear;

const group = console.group;
const dir = console.dir;
const assert = console.assert;
const table = console.table;

export default function executeCode(activeFile, files, addLog) {
  console.log = function (...args) {
    addLog("log", ...args);
    log.apply(console, args);
  };

  console.warn = function (...args) {
    addLog("warn", ...args);
    warn.apply(console, args);
  };

  console.error = function (...args) {
    addLog("error", ...args);
    error.apply(console, args);
  };

  console.clear = function (...args) {
    addLog("clear", ...args);
    clear.apply(console, args);
  };

  console.group = function (...args) {
    addLog("group", ...args);
    group.apply(console, args);
  };

  console.dir = function (...args) {
    addLog("dir", ...args);
    dir.apply(console, args);
  };

  console.assert = function (...args) {
    addLog("assert", ...args);
    assert.apply(console, args);
  };

  console.table = function (...args) {
    addLog("table", ...args);
    table.apply(console, args);
  };

  try {
    const transpiledFiles = files.map(
      ({ name, content }) =>
        `{
      filename: "${name}",
      func: function (require, exports) {
        ${transpile(content)}
      },
      exports: {}
    }
  `
    );

    const code = `
    const modules = [${transpiledFiles.join(",")}];
    const require = function(file) {
    let name = file.split('.js').shift().toLowerCase()
    const module = modules.find(({ filename }) =>  filename === name);

    if (!module) {
      throw new Error('Can not find "' + file + '" file.');
    }

    module.func(require, module.exports);
    return module.exports;
    };
    modules[${activeFile}].func(require, modules[${activeFile}].exports);
    `;
    
    // eslint-disable-next-line no-new-func
    const func = new Function(transpile(code));
    func();
  } catch (error) {
    console.error(handleError(error));
  }
}

function handleError(error) {
  if (error instanceof SyntaxError) {
    return `SyntaxError ${error.message?.replace("unknown: ", "")}`;
  } else if (error instanceof RangeError) {
    return `RangeError ${error.message}`;
  } else if (error instanceof EvalError) {
    return `EvalError ${error.message}`;
  } else if (error instanceof ReferenceError) {
    return `ReferenceError ${error.message}`;
  } else if (error instanceof TypeError) {
    return `TypeError ${error.message}`;
  } else if (error instanceof URIError) {
    return `URIError ${error.message}`;
  } else if (error instanceof Error) {
    return `Error ${error.message}`;
  }
   else {
    return `UnknownError ${error.message}`;
  }
}

const getFilename = filename => filename.split(/\./).shift().toLowerCase()

// eslint-disable-next-line
function isSameFilename(name1, name2) {
  return getFilename(name1) === getFilename(name2)
}
